<template>
    <RadioGroup >
        <RadioGroupLabel class="sr-only">
            {{ plan_name }}
        </RadioGroupLabel>
        <div class="bg-white rounded-md -space-y-px">
            <RadioGroupOption as="template" v-for="(plan, planIdx) in plans" :key="plan.name" :value="planIdx" v-slot="{ checked, active }" @click="$emit('input',$event.target.value)">
                <div :class="[planIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '', planIdx === plans.length - 1 ? 'rounded-bl-md rounded-br-md' : '', checked ? 'bg-green-50 border-green-200 z-10' : 'border-gray-200', 'relative border p-4 flex cursor-pointer focus:outline-none']">
                    <span :class="[checked ? 'bg-green-600 border-transparent' : 'bg-white border-gray-300', active ? 'ring-2 ring-offset-2 ring-green-500' : '', 'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center']" aria-hidden="true">
                        <span class="rounded-full bg-white w-1.5 h-1.5" />
                    </span>
                    <div class="ml-3 flex flex-col w-full">
                        <RadioGroupLabel as="span" :class="[checked ? 'text-purple-900' : 'text-gray-900', 'text-sm font-bold flex justify-between']">
                            {{ plan.name }}
                            <span>{{ plan.price }}</span>
                        </RadioGroupLabel>
                        <RadioGroupDescription as="span" :class="[checked ? 'text-purple-700' : 'text-gray-500', 'block text-sm']">
                            {{ plan.description }}
                        </RadioGroupDescription>
                    </div>
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'


export default {
    components: {
        RadioGroup,
        RadioGroupDescription,
        RadioGroupLabel,
        RadioGroupOption,
    },
    props: {
        plan_name: String,
        plans: Object,
        selected: String,
    }
}
</script>
